// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_string = require("rescript/lib/js/js_string.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("./common/http.res.js");
var Image$ReactHooksTemplate = require("./common/image.res.js");
var Utils$ReactHooksTemplate = require("./common/utils.res.js");
var DomainModel$ReactHooksTemplate = require("./settings/domainModel.res.js");

function empty(param) {
  return {
          email: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.empty, undefined),
          password: "",
          passwordConfirmation: "",
          token: ""
        };
}

function setEmail(email, t) {
  return {
          email: email,
          password: t.password,
          passwordConfirmation: t.passwordConfirmation,
          token: t.token
        };
}

function setPassword(password, t) {
  return {
          email: t.email,
          password: password,
          passwordConfirmation: t.passwordConfirmation,
          token: t.token
        };
}

function setPasswordConfirmation(passwordConfirmation, t) {
  return {
          email: t.email,
          password: t.password,
          passwordConfirmation: passwordConfirmation,
          token: t.token
        };
}

function setToken(token, t) {
  return {
          email: t.email,
          password: t.password,
          passwordConfirmation: t.passwordConfirmation,
          token: token
        };
}

function email(t) {
  return t.email;
}

function password(t) {
  return t.password;
}

function passwordConfirmation(t) {
  return t.passwordConfirmation;
}

function token(t) {
  return t.token;
}

function decode(json) {
  return {
          email: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.create, Json_decode.field("email", Json_decode.string, json)),
          password: "",
          passwordConfirmation: "",
          token: Json_decode.field("token", Json_decode.string, json)
        };
}

function toJson(t) {
  return Json_encode.object_({
              hd: [
                "email",
                Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, t.email)
              ],
              tl: {
                hd: [
                  "token",
                  t.token
                ],
                tl: {
                  hd: [
                    "password",
                    t.password
                  ],
                  tl: {
                    hd: [
                      "password_confirmation",
                      t.passwordConfirmation
                    ],
                    tl: /* [] */0
                  }
                }
              }
            });
}

var VerifyEmailParams = {
  empty: empty,
  setEmail: setEmail,
  setPassword: setPassword,
  setPasswordConfirmation: setPasswordConfirmation,
  setToken: setToken,
  email: email,
  password: password,
  passwordConfirmation: passwordConfirmation,
  token: token,
  decode: decode,
  toJson: toJson
};

function SetPassword(props) {
  var uuid = props.uuid;
  var match = React.useState(function (param) {
        return empty();
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        
      });
  var setError = match$1[1];
  var isLengthValid = state.password.length >= 8;
  var match$2 = Js_string.match_(/[a-zA-Z]/, state.password);
  var hasAlphabet = match$2 !== undefined;
  var match$3 = Js_string.match_(/\d/, state.password);
  var hasNumber = match$3 !== undefined;
  var match$4 = Js_string.match_(/[^a-zA-Z0-9]/, state.password);
  var hasSpecialChar = match$4 !== undefined;
  var match$5 = state.password;
  var isStrongPassword = match$5 === "" || isLengthValid && hasAlphabet && hasNumber && hasSpecialChar ? undefined : Caml_option.some(JsxRuntime.jsx("p", {
              children: "Password not strong enough",
              className: "text-red-500 text-sm float-left pt-1"
            }));
  var x = state.passwordConfirmation;
  var isPasswordMatch = x === "" ? undefined : (
      x === state.password ? Caml_option.some(JsxRuntime.jsx("p", {
                  children: "Both passwords are a match",
                  className: "text-green-500 text-sm float-left pt-1"
                })) : Caml_option.some(JsxRuntime.jsx("p", {
                  children: "Passwords are not a match",
                  className: "text-red-500 text-sm float-left pt-1"
                }))
    );
  var handleFormInputChange = function ($$event) {
    var name = $$event.target.name;
    var value = $$event.target.value;
    switch (name) {
      case "user[email]" :
          return Curry._1(setState, (function (state) {
                        return setEmail(value, state);
                      }));
      case "user[password]" :
          return Curry._1(setState, (function (state) {
                        return setPassword(value, state);
                      }));
      case "user[password_confirmation]" :
          return Curry._1(setState, (function (state) {
                        return setPasswordConfirmation(value, state);
                      }));
      default:
        return ;
    }
  };
  var validateForm = function (param) {
    if (state.password === "" || state.passwordConfirmation === "") {
      return true;
    } else {
      return state.password !== state.passwordConfirmation;
    }
  };
  React.useEffect((function (param) {
          var url = "/api/v1/users/confirm_user/?uuid=" + uuid;
          Js_promise.then_((function (response) {
                  var status = Json_decode.field("status", (function (param) {
                          return Json_decode.withDefault("failed", Json_decode.string, param);
                        }), response);
                  console.log(status);
                  if (status === "success") {
                    var user = Json_decode.field("user", decode, response);
                    Curry._1(setState, (function (state) {
                            return setEmail(user.email, state);
                          }));
                    Curry._1(setState, (function (state) {
                            return setToken(user.token, state);
                          }));
                  }
                  return Promise.resolve();
                }), Http$ReactHooksTemplate.fetchGetJSON(url));
        }), []);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("img", {
                            className: "h-full w-full object-cover",
                            src: Image$ReactHooksTemplate.signupOnboarding
                          }),
                      className: "w-1/2 max-h-full"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("img", {
                                            className: "h-40-px w-120-px",
                                            src: Image$ReactHooksTemplate.geckolystLogoWithText
                                          }),
                                      className: "flex items-center"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("button", {
                                              children: "Need help?",
                                              className: "text-sm text-darksilver hover:text-indigo-600 p-2"
                                            }),
                                        JsxRuntime.jsxs("button", {
                                              children: [
                                                JsxRuntime.jsx("img", {
                                                      src: Image$ReactHooksTemplate.headphone
                                                    }),
                                                JsxRuntime.jsx("div", {
                                                      children: "Contact Us",
                                                      className: "flex items-center h-full w-20"
                                                    })
                                              ],
                                              className: "rounded-lg text-darkcharcoal border border-gainsboro flex gap-2 p-2 font-medium text-sm"
                                            })
                                      ],
                                      className: "flex gap-2"
                                    })
                              ],
                              className: "flex justify-between w-full px-6 py-4 border-b border-platinum bg-white"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("form", {
                                    children: [
                                      JsxRuntime.jsx("input", {
                                            name: "token",
                                            type: "hidden",
                                            value: state.token
                                          }),
                                      JsxRuntime.jsx("input", {
                                            name: "authenticity_token",
                                            type: "hidden",
                                            value: Utils$ReactHooksTemplate.csrfToken
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("p", {
                                                            children: "Create your password",
                                                            className: "text-darkcharcoal text-2xl font-medium px-4"
                                                          }),
                                                      JsxRuntime.jsx("h1", {
                                                            children: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, state.email),
                                                            className: "text-darksilver text-base font-normal px-4"
                                                          })
                                                    ],
                                                    className: "text-center flex flex-col gap-2 w-1/2"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsxs("div", {
                                                            children: [
                                                              JsxRuntime.jsx("label", {
                                                                    children: "Password",
                                                                    className: "float-left text-darkcharcoal text-sm font-medium mb-1",
                                                                    name: "password"
                                                                  }),
                                                              JsxRuntime.jsx("input", {
                                                                    className: "rounded-lg bg-white w-full h-40-px text-sm font-normal pl-4 pr-3 py-3 focus:border focus:border-black",
                                                                    id: "user_password",
                                                                    autoComplete: "off",
                                                                    name: "user[password]",
                                                                    type: "password",
                                                                    value: state.password,
                                                                    onChange: handleFormInputChange
                                                                  }),
                                                              isStrongPassword !== undefined ? Caml_option.valFromOption(isStrongPassword) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                                                            ],
                                                            className: ""
                                                          }),
                                                      JsxRuntime.jsxs("div", {
                                                            children: [
                                                              JsxRuntime.jsx("label", {
                                                                    children: "Re-enter password",
                                                                    className: "float-left text-darkcharcoal text-sm font-medium mb-1",
                                                                    name: "password_confirmation"
                                                                  }),
                                                              JsxRuntime.jsx("input", {
                                                                    className: "rounded-lg bg-white w-full h-40-px text-sm font-normal pl-4 pr-3 py-3 focus:border focus:border-black",
                                                                    id: "user_password_confirmation",
                                                                    autoComplete: "off",
                                                                    name: "user[password_confirmation]",
                                                                    type: "password",
                                                                    value: state.passwordConfirmation,
                                                                    onChange: handleFormInputChange
                                                                  }),
                                                              isPasswordMatch !== undefined ? Caml_option.valFromOption(isPasswordMatch) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                                                            ],
                                                            className: ""
                                                          })
                                                    ],
                                                    className: "text-center flex flex-col gap-8 w-1/2 max-w-390-px"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("p", {
                                                            children: "Password must include",
                                                            className: "text-darksilver text-sm font-normal"
                                                          }),
                                                      JsxRuntime.jsxs("ul", {
                                                            children: [
                                                              JsxRuntime.jsxs("li", {
                                                                    children: [
                                                                      JsxRuntime.jsx("div", {
                                                                            children: isLengthValid ? JsxRuntime.jsx("img", {
                                                                                    src: Image$ReactHooksTemplate.greenCheckbox
                                                                                  }) : JsxRuntime.jsx("img", {
                                                                                    src: Image$ReactHooksTemplate.lightErrorIcon
                                                                                  })
                                                                          }),
                                                                      JsxRuntime.jsx("p", {
                                                                            children: "at least 8 characters",
                                                                            className: "text-darksilver text-sm font-normal"
                                                                          })
                                                                    ],
                                                                    className: "flex items-center space-x-3"
                                                                  }),
                                                              JsxRuntime.jsxs("li", {
                                                                    children: [
                                                                      JsxRuntime.jsx("div", {
                                                                            children: hasAlphabet ? JsxRuntime.jsx("img", {
                                                                                    src: Image$ReactHooksTemplate.greenCheckbox
                                                                                  }) : JsxRuntime.jsx("img", {
                                                                                    src: Image$ReactHooksTemplate.lightErrorIcon
                                                                                  })
                                                                          }),
                                                                      JsxRuntime.jsx("p", {
                                                                            children: "at least 1 alphabet",
                                                                            className: "text-darksilver text-sm font-normal"
                                                                          })
                                                                    ],
                                                                    className: "flex items-center space-x-3"
                                                                  }),
                                                              JsxRuntime.jsxs("li", {
                                                                    children: [
                                                                      JsxRuntime.jsx("div", {
                                                                            children: hasNumber ? JsxRuntime.jsx("img", {
                                                                                    src: Image$ReactHooksTemplate.greenCheckbox
                                                                                  }) : JsxRuntime.jsx("img", {
                                                                                    src: Image$ReactHooksTemplate.lightErrorIcon
                                                                                  })
                                                                          }),
                                                                      JsxRuntime.jsx("p", {
                                                                            children: "a number",
                                                                            className: "text-darksilver text-sm font-normal"
                                                                          })
                                                                    ],
                                                                    className: "flex items-center space-x-3"
                                                                  }),
                                                              JsxRuntime.jsxs("li", {
                                                                    children: [
                                                                      JsxRuntime.jsx("div", {
                                                                            children: hasSpecialChar ? JsxRuntime.jsx("img", {
                                                                                    src: Image$ReactHooksTemplate.greenCheckbox
                                                                                  }) : JsxRuntime.jsx("img", {
                                                                                    src: Image$ReactHooksTemplate.lightErrorIcon
                                                                                  })
                                                                          }),
                                                                      JsxRuntime.jsx("p", {
                                                                            children: "a special character",
                                                                            className: "text-darksilver text-sm font-normal"
                                                                          })
                                                                    ],
                                                                    className: "flex items-center space-x-3"
                                                                  })
                                                            ],
                                                            className: "space-y-3"
                                                          })
                                                    ],
                                                    className: "flex flex-col gap-6 w-1/2 max-w-390-px"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx("div", {
                                                          children: JsxRuntime.jsx("input", {
                                                                className: "py-10-px px-30-px rounded-lg w-full " + (
                                                                  validateForm() ? "disabled-input bg-lightgray text-white" : "bg-black text-ufogreen cursor-pointer"
                                                                ),
                                                                disabled: validateForm(),
                                                                name: "commit",
                                                                type: "submit",
                                                                value: "Save and Continue"
                                                              }),
                                                          className: "w-full"
                                                        }),
                                                    className: "flex items-center w-1/2  max-w-390-px"
                                                  })
                                            ],
                                            className: "flex items-center justify-center flex-col gap-8"
                                          })
                                    ],
                                    className: "w-full justify-center",
                                    autoComplete: "off",
                                    charSet: "UTF-8",
                                    onSubmit: (function ($$event) {
                                        $$event.preventDefault();
                                        Js_promise.then_((function (response) {
                                                var status = Json_decode.field("status", (function (param) {
                                                        return Json_decode.withDefault("failed", Json_decode.string, param);
                                                      }), response);
                                                if (status === "success") {
                                                  RescriptReactRouter.push("/users/sign_in");
                                                  window.location.reload();
                                                } else {
                                                  var error = Json_decode.field("errors", Json_decode.string, response);
                                                  Curry._1(setError, (function (param) {
                                                          return error;
                                                        }));
                                                }
                                                return Promise.resolve();
                                              }), Http$ReactHooksTemplate.fetchPostEncodedJSON("/api/v1/users/set_password", Json_encode.object_({
                                                      hd: [
                                                        "user",
                                                        toJson(state)
                                                      ],
                                                      tl: /* [] */0
                                                    })));
                                      })
                                  }),
                              className: "flex items-center justify-center w-full h-4/5"
                            })
                      ],
                      className: "w-1/2 max-h-full bg-ghostwhiteblue"
                    })
              ],
              className: "flex h-full"
            });
}

var make = SetPassword;

exports.VerifyEmailParams = VerifyEmailParams;
exports.make = make;
/* react Not a pure module */
